import React from "react";
import { Link } from "react-router-dom";

import { useQuery } from "@apollo/client";

import { GET_UTILITIES } from "./queries";

import Loader from "../../common/Loader";
import Tabs from "../Tabs";

import blankImg from "../../common/img/components.png";

import styled from "styled-components";

const Container = styled.div`
  padding-top: 30px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  ::after {
    content: "";
    flex: auto;
    min-width: 32%;
    max-width: 32%;
  }

  .card {
    max-width: 32%;
    margin-bottom: 2%;
  }
`;

const BlankState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 50px 0px;
  padding: 50px 20px;
  border: 1px solid #ccc;
  border-radius: 4px;

  img {
    max-width: 300px;
  }

  .header {
    font-size: 20px;
    margin: 20px 0px 15px;
    font-weight: bold;
  }

  .desc {
    font-size: 16px;
    margin-bottom: 20px;
  }
`;

const Utilities = ({ projectId }) => {
  const { loading, error, data } = useQuery(GET_UTILITIES, {
    fetchPolicy: "network-only",
    variables: {
      projectId: parseInt(projectId)
    }
  });

  if (loading) return <Loader />;
  if (error) return <div>Error</div>;

  return (
    <React.Fragment>
      <div className="page-header">
        <div className="page-header-wrapper container">
          <div className="heading">
            <h1 className="breadcrumb">Components /</h1>
            <h1 className="breadcrumb active">Utilities</h1>
          </div>

          <div className="actions">
            <Link className="action" to="/components/utilities/new">
              New Utility
            </Link>{" "}
            <Link className="action" to="/components/new">
              New Component
            </Link>
          </div>
        </div>
      </div>

      <div className="container">
        <Tabs />

        {data.utilities.length == 0 && (
          <BlankState>
            <img src={blankImg} />
            <div className="header">No Utilities Found</div>
            <p className="desc">
              Utilities are helper classes that are commonly used to quickly
              apply styles to components.
            </p>
            <div className="action">
              <Link className="btn btn-primary" to="/components/utilities/new">
                Create Utility
              </Link>
            </div>
          </BlankState>
        )}

        <Container>
          {data.utilities.map((u, i) => {
            return (
              <div key={`utility${i}`} className="card">
                <div className="card-body">
                  <h2 className="card-title">{u.selector}</h2>
                  <div className="actions">
                    <Link
                      to={`/components/utilities/${u.id}`}
                      className="btn btn-primary"
                    >
                      Edit
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Utilities;
